// libs
import styled, { css } from 'styled-components'
// themes
import colors from 'themes/colors'
// utils
import { darken } from 'polished'

export const BUTTON_PRESETS = {
  PURPLE: css<{ isActive?: boolean }>`
    transition: 0.25s box-shadow cubic-bezier(0.4, 0, 0.2, 1) 0ms;

    box-shadow:
      0 3px 1px -2px rgba(0, 0, 0, 0.2),
      0 2px 2px 0 rgba(0, 0, 0, 0.14),
      0 1px 5px 0 rgba(0, 0, 0, 0.12);

    &:hover {
      box-shadow:
        0 2px 4px -1px rgba(0, 0, 0, 0.2),
        0 4px 5px 0 rgba(0, 0, 0, 0.14),
        0 1px 10px 0 rgba(0, 0, 0, 0.12);
    }

    ${({ isActive }) =>
      isActive
        ? css`
            background-color: ${colors.purple300};

            path {
              fill: ${colors.white};
            }
          `
        : css`
            background-color: ${colors.white100};
            border: 1px solid ${colors.purple300};

            path {
              fill: ${colors.purple300};
            }
          `};
  `,
  DARK_BLUE: css<{ isActive?: boolean }>`
    &:hover {
      background-color: ${({ isActive }) =>
        isActive ? darken(0.1, colors.white100) : darken(0.1, colors.darkBlue400)};
    }

    ${({ isActive }) =>
      isActive
        ? css`
            background-color: ${colors.white100};

            path {
              fill: ${colors.darkBlue400};
            }
          `
        : css`
            background-color: ${colors.darkBlue400};

            path {
              fill: ${colors.white};
            }
          `};
  `,
  DISABLED: css`
    background: ${colors.gray280};

    path {
      fill: ${colors.gray900};
    }
  `,
  RED: css`
    &:hover {
      background-color: ${darken(0.1, colors.red300)};
    }

    background-color: ${colors.red300};

    path {
      fill: ${colors.white};
    },
  `,
  RED_INVERTED: css`
    border: 1px solid ${colors.red300};
    box-shadow:
      0 3px 1px -2px rgba(0, 0, 0, 0.2),
      0 2px 2px 0 rgba(0, 0, 0, 0.14),
      0 1px 5px 0 rgba(0, 0, 0, 0.12);

    &:hover {
      box-shadow:
        0 2px 4px -1px rgba(0, 0, 0, 0.2),
        0 4px 5px 0 rgba(0, 0, 0, 0.14),
        0 1px 10px 0 rgba(0, 0, 0, 0.12);
    }

    path {
      fill: ${colors.red300};
    }
  `
}

export type ButtonPresets = keyof typeof BUTTON_PRESETS

export const ButtonWrapper = styled.div<{ isActive: boolean; disabled?: boolean; preset: ButtonPresets }>`
  align-items: center;
  border-radius: 22px;
  display: flex;
  min-height: 40px;
  justify-content: center;
  min-width: 40px;
  cursor: pointer;

  ${({ preset }) => preset && BUTTON_PRESETS[preset]};
`
